export const environment = {
  production: false,
  loginUrl: 'https://login.input4you.be/LoginAPI/',
  atelierController: 'https://atelierapi-testing.input4you.be/'
  //atelierController: 'http://localhost:42879/',
};
